import React from 'react'

const IconBrandPlaceholder = ({
  className = '',
  strokeWidth = '1'
}: {
  className?: string
  strokeWidth?: string
}): JSX.Element => {
  return (
    <div className={`flex size-8 items-center justify-center ${className}`}>
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          x="10"
          y="2"
          width="6"
          height="6"
          rx="3"
          className="fill-gray-700 group-hover:fill-primary-400 group-active:fill-primary-400 group-aria-selected:fill-primary-400"
        />
        <rect
          x="3"
          y="8"
          width="6"
          height="6"
          rx="1"
          className="fill-gray-700 group-hover:fill-primary-400 group-active:fill-primary-400 group-aria-selected:fill-primary-400"
        />
        <path
          d="M0 6L4 0L8 6H0Z"
          className="fill-gray-700 group-hover:fill-primary-400 group-active:fill-primary-400 group-aria-selected:fill-primary-400"
        />
      </svg>
    </div>
  )
}

export default IconBrandPlaceholder
